import { BrowserRouter as Router, Routes, Route } from 'react-router';
import { AuthProvider } from './contexts/AuthContext';
import { RequireAuth, RequireApproved, RequireRole, RootRedirect } from './components/RouteGuards';
import GuestOnly from './auth/GuestOnly';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';
import PendingPage from './components/PendingPage';
import OperatorWorkspace from './components/operator/OperatorWorkspace';
import AdminPage from './components/admin/AdminPage';
import AdminOperatorMap from './components/admin/AdminOperatorMap';
import CableRouteTester from './components/admin/CableRouteTester';
import ParsiMapPage from './components/ParsiMapPage';
import ConsultPage from './components/consult/ConsultPage';
import InstallerAuthPage from './components/installer/InstallerAuthPage';
import InstallerPendingPage from './components/installer/InstallerPendingPage';
import InstallerDashboardPage from './components/installer/InstallerDashboardPage';
import InstallerJobDetailPage from './components/installer/InstallerJobDetailPage';
import StageCapturePage from './components/installer/StageCapturePage';
import InstallerProfilePage from './components/installer/InstallerProfilePage';
import UpdatePrompt from './components/installer/UpdatePrompt';
import CustomerHandoverPage from './components/customer/CustomerHandoverPage';
import CustomerAuthPage from './components/customer/CustomerAuthPage';
import DesignPage from './components/operator/DesignPage';
import DesignApprovalPage from './components/admin/installers/DesignApprovalPage';
import SupervisorPage from './components/supervisor/SupervisorPage';
import CarrierShell from './components/carrier/CarrierShell';
import ContractorAuthPage from './components/contractor/ContractorAuthPage';
import ContractorPendingPage from './components/contractor/ContractorPendingPage';
import ContractorDashboardPage from './components/contractor/ContractorDashboardPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <UpdatePrompt />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<GuestOnly><LoginPage /></GuestOnly>} />
          <Route path="/register" element={<GuestOnly><RegisterPage /></GuestOnly>} />
          <Route path="/pending" element={<RequireAuth><PendingPage /></RequireAuth>} />
          <Route path="/operator" element={<RequireRole role="operator"><OperatorWorkspace /></RequireRole>} />
          <Route path="/design" element={<RequireRole role="operator"><CarrierShell><DesignPage /></CarrierShell></RequireRole>} />
          <Route path="/admin/operator-map" element={<RequireRole role="admin"><AdminOperatorMap /></RequireRole>} />
          <Route path="/admin/:tab?/:sub?" element={<RequireRole role="catalogue_admin"><CarrierShell><AdminPage /></CarrierShell></RequireRole>} />
          <Route path="/design-approval" element={<RequireRole role="design_approver"><CarrierShell><DesignApprovalPage /></CarrierShell></RequireRole>} />
          <Route path="/supervisor/*" element={<RequireRole role="supervisor"><CarrierShell><SupervisorPage /></CarrierShell></RequireRole>} />
          <Route path="/supervisor/oversight/:sub?" element={<RequireRole role="supervisor"><CarrierShell><SupervisorPage /></CarrierShell></RequireRole>} />
          <Route path="/cable-test" element={<RequireRole role="admin"><CableRouteTester /></RequireRole>} />
          <Route path="/map" element={<RequireApproved><ParsiMapPage /></RequireApproved>} />
          <Route path="/consult" element={<ConsultPage />} />
          {/* /installer, /installer/login and /installer/signup all resolve to
              the single phone-first auth flow (one phone+OTP, then branch to
              login or registration). The three paths are kept so existing links
              and bookmarks (e.g. dashboard/pending redirects to
              /installer/login) keep working. */}
          <Route path="/installer" element={<InstallerAuthPage />} />
          <Route path="/installer/signup" element={<InstallerAuthPage />} />
          <Route path="/installer/pending" element={<InstallerPendingPage />} />
          <Route path="/installer/login" element={<InstallerAuthPage />} />
          <Route path="/installer/dashboard" element={<InstallerDashboardPage />} />
          <Route path="/installer/profile" element={<InstallerProfilePage />} />
          <Route path="/installer/job/:id/stage/:jobStageId" element={<StageCapturePage />} />
          <Route path="/installer/job/:id" element={<InstallerJobDetailPage />} />
          <Route path="/r/:token" element={<CustomerHandoverPage />} />
          <Route path="/customer-register" element={<CustomerAuthPage />} />
          {/* Contractor (پیمانکار) - field role (phone-OTP), self-guarding pages
              like the installer surface (ungated here). */}
          <Route path="/contractor" element={<ContractorAuthPage />} />
          <Route path="/contractor/login" element={<ContractorAuthPage />} />
          <Route path="/contractor/signup" element={<ContractorAuthPage />} />
          <Route path="/contractor/pending" element={<ContractorPendingPage />} />
          <Route path="/contractor/dashboard" element={<ContractorDashboardPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
